/* tslint:disable */
/* eslint-disable */
/**
 * Ameta Delivery API
 * This API manages the projects and docuements that are stored in the Ameta Document Delivery. The API used oAuth2 flow for authorization.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShareProjectCompanyAccess
 */
export interface ShareProjectCompanyAccess {
    /**
     * 
     * @type {string}
     * @memberof ShareProjectCompanyAccess
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ShareProjectCompanyAccess
     */
    accessType?: string;
}

export function ShareProjectCompanyAccessFromJSON(json: any): ShareProjectCompanyAccess {
    return ShareProjectCompanyAccessFromJSONTyped(json, false);
}

export function ShareProjectCompanyAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareProjectCompanyAccess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'accessType': !exists(json, 'accessType') ? undefined : json['accessType'],
    };
}

export function ShareProjectCompanyAccessToJSON(value?: ShareProjectCompanyAccess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'accessType': value.accessType,
    };
}


